// import React, { useRef } from 'react';
// import heroImage1 from '../../main_assets/hero.png';
// import heroImage2 from '../../main_assets/hero2.png';

// const Header = () => {
//   const headerRef = useRef(null);

//   // Slides array
//   const slides = [
//     {
//       image: heroImage1,
//       title: 'Decobra Design Firm',
//       subtitle: 'Refining Modern Design',
//     },
//     {
//       image: heroImage2,
//       title: 'Innovative Solutions',
//       subtitle: 'Transforming Creativity',
//     },
//   ];

//   // Duplicate the slides to allow seamless looping
//   const extendedSlides = [...slides, ...slides];

//   return (
//     <div
//       ref={headerRef}
//       className="header-container"
//       style={{
//         position: 'relative',
//         display: 'flex',
//         backgroundColor: '#E54141',
//         padding: '80px 0',
//         height: '105vh',
//         overflow: 'hidden',
//       }}
//     >
//       {/* Sliding Container */}
//       <div
//         className="header-slider"
//         style={{
//           display: 'flex',
//           width: `calc(${extendedSlides.length * 100}% + ${
//             extendedSlides.length * 20
//           }px)`, // Adjust width to include margins
//           animation: 'scrollLeft 20s linear infinite',
//           gap: '20px', // Add 20px gap between slides
//           boxSizing: 'border-box',
//         }}
//       >
//         {extendedSlides.map((slide, index) => (
//           <div
//             key={index}
//             className="header-slide"
//             style={{
//               flex: '0 0 calc(100% - 20px)', 
//               marginRight: index === extendedSlides.length - 1 ? '0' : '20px', 
//               position: 'relative',
//               boxSizing: 'border-box',
//             }}
//           >
//             {/* Slide Image */}
//             <img
//               src={slide.image}
//               alt={slide.title}
//               style={{
//                 objectFit: 'cover',
//                 width: '100%',
//                 height: '100%',
//               }}
//             />
//             {/* Text Overlay */}
//             <div
//               className="header-text-wrapper"
//               style={{
//                 position: 'absolute',
//                 left: '5%',
//                 top: '70%',
//                 transform: 'translateY(-50%)',
//                 zIndex: 1,
//               }}
//             >
//               <h1
//                 style={{
//                   fontFamily: 'Poppins-SemiBold',
//                   color: '#E9E9E1',
//                   fontSize: 'clamp(40px, 6vw, 90px)',
//                   fontWeight: '900',
//                   margin: '0 0 20px 0',
//                 }}
//               >
//                 {slide.title}
//               </h1>
//               <p
//                 style={{
//                   fontFamily: 'Poppins-Regular',
//                   color: '#E9E9E1',
//                   fontSize: '20px',
//                 }}
//               >
//                 {slide.subtitle}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Global Animation */}
//       <style>{`
//         @keyframes scrollLeft {
//           from {
//             transform: translateX(0);
//           }
//           to {
//             transform: translateX(calc(-100% - 20px));
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Header;







// import React, { useEffect, useState, useRef } from "react";
// import heroImage1 from "../../main_assets/hero1.png";
// import heroImage2 from "../../main_assets/hero2.png";
// import heroImage3 from "../../main_assets/hero.png";

// const Header = () => {
//   const [isHeaderVisible, setHeaderVisible] = useState(false);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const headerRef = useRef(null);

//   const slides = [
//     {
//       image: heroImage1,
//       title: "Decobra Design Firm",
//       subtitle: "Refining Modern Design",
//     },
//     {
//       image: heroImage2,
//       title: "Innovative Solutions",
//       subtitle: "Transforming Creativity",
//     },
//     {
//       image: heroImage3,
//       title: "Innovative Solutions",
//       subtitle: "Transforming Creativity",
//     },
//   ];

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setHeaderVisible(true);
//           }
//         });
//       },
//       { threshold: 0.5 }
//     );

//     if (headerRef.current) {
//       observer.observe(headerRef.current);
//     }

//     return () => {
//       if (headerRef.current) {
//         observer.unobserve(headerRef.current);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
//     }, 5000); // Change slide every 5 seconds

//     return () => clearInterval(interval);
//   }, [slides.length]);

//   return (
//     <div
//       ref={headerRef}
//       className="header-container"
//       style={{
//         display: "flex",
//         flexDirection: "row",
//         backgroundColor: "#E54141",
//         padding: "80px 0",
//         height: "100vh",
//         overflow: "hidden",
//         opacity: isHeaderVisible ? 1 : 0,
//         transform: isHeaderVisible ? "translateY(0)" : "translateY(20px)",
//         transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
//       }}
//     >
//       <div
//         className="header-text-container"
//         style={{
//           position: "relative",
//         }}
//       >
//         <div
//           className="header-text-wrapper"
//           style={{
//             position: "absolute",
//             left: "5%",
//             top: "70%",
//             transform: "translateY(-0%)",
//             zIndex: 1,
//           }}
//         >
//           <h1
//             className="header-title"
//             style={{
//               fontFamily: "Poppins-SemiBold",
//               color: "#E9E9E1",
//               fontSize: "clamp(40px, 6vw, 90px)",
//               fontWeight: "900",
//               whiteSpace: "nowrap",
//               margin: "0 0 20px 0",
//               width: "100%",
//             }}
//           >
//             {slides[currentSlide].title}
//           </h1>
//           <p
//             style={{
//               fontFamily: "Poppins-Regular",
//               color: "#E9E9E1",
//               fontSize: "20px",
//             }}
//           >
//             {slides[currentSlide].subtitle}
//           </p>
//         </div>
//       </div>

//       <div
//         className="header-image-container"
//         style={{
//           flex: "1 0 70%",
//           position: "relative",
//           marginLeft: "-10%",
//           display: "flex",
//           transition: "transform 1s ease-in-out",
//           transform: `translateX(-${currentSlide * 100}%)`, 
//         }}
//       >
//         {slides.map((slide, index) => (
//           <img
//             key={index}
//             src={slide.image}
//             alt={slide.title}
//             className="header-image"
//             style={{
//               objectFit: "cover",
//               height: "100%",
//               width: "100%",
//               display: "block",
//               flex: "0 0 100%", 
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Header;









import React, { useState, useEffect, useRef } from 'react';
import heroImage1 from '../../main_assets/hero.png';
import heroImage2 from '../../main_assets/hero2.png';
import { getDocs, collection, query, orderBy, limit, where, onSnapshot, updateDoc, increment, doc } from 'firebase/firestore';
import { db } from '../../firebase';

const Header = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [nextSlide, setNextSlide] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);
  const [featuredProjects, setFeaturedProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Slides array
  const slides = [
    {
      image: heroImage1,
      title: 'Decobra Design Firm',
      subtitle: 'Refining Modern Design',
    },
    {
      image: heroImage2,
      title: 'Innovative Solutions',
      subtitle: 'Transforming Creativity',
    }
  ];

  // Automatic slide change
  useEffect(() => {
    const slideInterval = setInterval(() => {
      if (!isAnimating) {
        setIsAnimating(true);
        
        // Prepare next slide
        const newNextSlide = (currentSlide + 1) % slides.length;
        setNextSlide(newNextSlide);

        // After animation completes, update current slide
        const animationTimer = setTimeout(() => {
          setCurrentSlide(newNextSlide);
          setIsAnimating(false);
        }, 1000); // Match this with CSS transition duration

        return () => clearTimeout(animationTimer);
      }
    }, 5000);

    return () => clearInterval(slideInterval);
  }, [currentSlide, isAnimating, slides.length]);

  useEffect(() => {
    const fetchFeaturedProjects = () => {
      const q = query(collection(db, 'projects'), where('isFeatured', '==', true));
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const fetchedProjects = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          featureImage: doc.data().featureImage,
        }));
        
        console.log('Fetched featured projects:', fetchedProjects); 
        setFeaturedProjects(fetchedProjects);
        setLoading(false); 
      }, (error) => {
        console.error('Error fetching featured projects:', error);
        setError(error.message);
        setLoading(false); 
      });

      return () => unsubscribe(); 
    };

    fetchFeaturedProjects();
  }, []);

  const fetchFeaturedProjects = async () => {
    try {
      const projectsCollection = collection(db, 'projects');
      const featuredProjectsQuery = query(
        projectsCollection,
        where('featured', '==', true),
        orderBy('createdAt', 'desc'),
        limit(4)
      );
      const snapshot = await getDocs(featuredProjectsQuery);
      const fetchedProjects = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setFeaturedProjects(fetchedProjects);
    } catch (error) {
      console.error("Error fetching featured projects:", error);
    }
  };

  return (
    <div
      className="header-container"
      style={{
        position: 'relative',
        display: 'flex',
        backgroundColor: '#E54141',
        padding: '80px 0',
        height: '105vh',
        overflow: 'hidden',
      }}
    >
      <div
        className="header-slider"
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        {slides.map((slide, index) => (
          <div
            key={index}
            className="header-slide"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              // zIndex: index === currentSlide ? 2 : 1,
              transform: 
                index === currentSlide 
                  ? 'translateX(0)' 
                  : index === nextSlide && isAnimating 
                    ? 'translateX(100%)' 
                    : 'translateX(-100%)',
              opacity: index === currentSlide ? 1 : 1,
              transition: 'transform 1s ease-in-out, opacity 1s ease-in-out',
            }}
          >
            {/* Slide Image */}
            <img
              src={slide.image}
              alt={slide.title}
              style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                zIndex: -1,
              }}
            />
            {/* Text Overlay */}
            <div
              className="header-text-wrapper"
              style={{
                position: 'absolute',
                left: '2%',
                top: '85%',
                transform: 'translateY(-50%)',
                zIndex: 3,
                opacity: index === currentSlide ? 1 : 1,
                transition: 'opacity 1s ease-in-out',
              }}
            >
              <h1
                style={{
                  fontFamily: 'Poppins-SemiBold',
                  color: '#E9E9E1',
                  fontSize: 'clamp(40px, 6vw, 90px)',
                  fontWeight: '900',
                  margin: '0 0 20px 0',
                }}
              >
                {slide.title}
              </h1>
              {/* <p
                style={{
                  fontFamily: 'Poppins-Regular',
                  color: '#E9E9E1',
                  fontSize: '20px',
                }}
              >
                {slide.subtitle}
              </p> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Header;










// import React, { useState, useEffect, useRef } from 'react';
// import heroImage1 from '../../main_assets/hero.png';
// import heroImage2 from '../../main_assets/hero2.png';
// import { getDocs, collection, query, orderBy, limit, where, onSnapshot, updateDoc, increment, doc } from 'firebase/firestore';
// import { db } from '../../firebase';

// const Header = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [nextSlide, setNextSlide] = useState(1);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [featuredProjects, setFeaturedProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Slides array
//   const slides = [
//     {
//       image: heroImage1,
//       title: 'Decobra Design Firm',
//       subtitle: 'Refining Modern Design',
//     },
//     {
//       image: heroImage2,
//       title: 'Innovative Solutions',
//       subtitle: 'Transforming Creativity',
//     }
//   ];

//   // Automatic slide change
//   useEffect(() => {
//     const slideInterval = setInterval(() => {
//       if (!isAnimating) {
//         setIsAnimating(true);
        
//         // Prepare next slide
//         const newNextSlide = (currentSlide + 1) % slides.length;
//         setNextSlide(newNextSlide);

//         // After animation completes, update current slide
//         const animationTimer = setTimeout(() => {
//           setCurrentSlide(newNextSlide);
//           setIsAnimating(false);
//         }, 1000); // Match this with CSS transition duration

//         return () => clearTimeout(animationTimer);
//       }
//     }, 5000);

//     return () => clearInterval(slideInterval);
//   }, [currentSlide, isAnimating, slides.length]);

//   useEffect(() => {
//     const fetchFeaturedProjects = () => {
//       const q = query(collection(db, 'projects'), where('isFeatured', '==', true));
//       const unsubscribe = onSnapshot(q, (querySnapshot) => {
//         const fetchedProjects = querySnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           featureImage: doc.data().featureImage,
//         }));
        
//         console.log('Fetched featured projects:', fetchedProjects); 
//         setFeaturedProjects(fetchedProjects);
//         setLoading(false); 
//       }, (error) => {
//         console.error('Error fetching featured projects:', error);
//         setError(error.message);
//         setLoading(false); 
//       });

//       return () => unsubscribe(); 
//     };

//     fetchFeaturedProjects();
//   }, []);

//   const fetchFeaturedProjects = async () => {
//     try {
//       const projectsCollection = collection(db, 'projects');
//       const featuredProjectsQuery = query(
//         projectsCollection,
//         where('featured', '==', true),
//         orderBy('createdAt', 'desc'),
//         limit(4)
//       );
//       const snapshot = await getDocs(featuredProjectsQuery);
//       const fetchedProjects = snapshot.docs.map(doc => ({
//         id: doc.id,
//         ...doc.data()
//       }));
//       setFeaturedProjects(fetchedProjects);
//     } catch (error) {
//       console.error("Error fetching featured projects:", error);
//     }
//   };

//   return (
//     <div
//       className="header-container"
//       style={{
//         position: 'relative',
//         display: 'flex',
//         backgroundColor: '#E54141',
//         padding: '80px 0',
//         height: '105vh',
//         overflow: 'hidden',
//       }}
//     >
//       <div
//         className="header-slider"
//         style={{
//           position: 'relative',
//           width: '100%',
//           height: '100%',
//           overflow: 'hidden',
//         }}
//       >
//         {featuredProjects.map((project, index) => (
//           <div
//             key={index}
//             className="header-slide"
//             style={{
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               width: '100%',
//               height: '100%',
//               zIndex: index === currentSlide ? 2 : 1,
//               transform: 
//                 index === currentSlide 
//                   ? 'translateX(0)' 
//                   : index === nextSlide && isAnimating 
//                     ? 'translateX(100%)' 
//                     : 'translateX(-100%)',
//               opacity: index === currentSlide ? 1 : 1,
//               transition: 'transform 1s ease-in-out, opacity 1s ease-in-out',
//             }}
//           >
//             {/* Slide Image */}
//             <img
//               src={project.featureImage || project.coverImage}
//               alt={project.title}
//               style={{
//                 objectFit: 'cover',
//                 width: '100%',
//                 height: '100%',
//               }}
//             />
//             {/* Text Overlay */}
//             <div
//               className="header-text-wrapper"
//               style={{
//                 position: 'absolute',
//                 left: '2%',
//                 top: '85%',
//                 transform: 'translateY(-50%)',
//                 zIndex: 3,
//                 opacity: index === currentSlide ? 1 : 1,
//                 transition: 'opacity 1s ease-in-out',
//               }}
//             >
//               <h1
//                 style={{
//                   fontFamily: 'Poppins-SemiBold',
//                   color: '#E9E9E1',
//                   fontSize: 'clamp(40px, 6vw, 90px)',
//                   fontWeight: '900',
//                   margin: '0 0 20px 0',
//                 }}
//               >
//                 {project.title}
//               </h1>
//               {/* <p
//                 style={{
//                   fontFamily: 'Poppins-Regular',
//                   color: '#E9E9E1',
//                   fontSize: '20px',
//                 }}
//               >
//                 {slide.subtitle}
//               </p> */}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Header;









// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { getDocs, collection, query, orderBy, limit, where, onSnapshot, updateDoc, increment, doc } from 'firebase/firestore';
// import heroImage1 from '../../main_assets/hero.png';
// import heroImage2 from '../../main_assets/hero2.png';
// import { db } from '../../firebase';

// const Header = () => {
//   const navigate = useNavigate();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [nextSlide, setNextSlide] = useState(1);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [featuredProjects, setFeaturedProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  

//   // Slides array
//   const slides = [
//     {
//       image: heroImage1,
//       title: 'Decobra Design Firm',
//       subtitle: 'Refining Modern Design',
//     },
//     {
//       image: heroImage2,
//       title: 'Innovative Solutions',
//       subtitle: 'Transforming Creativity',
//     }
//   ];

//   // Automatic slide change
//   useEffect(() => {
//     const slideInterval = setInterval(() => {
//       if (!isAnimating) {
//         setIsAnimating(true);
        
//         // Prepare next slide
//         const newNextSlide = (currentSlide + 1) % featuredProjects.length;
//         setNextSlide(newNextSlide);

//         // After animation completes, update current slide
//         const animationTimer = setTimeout(() => {
//           setCurrentSlide(newNextSlide);
//           setIsAnimating(false);
//         }, 1000);

//         return () => clearTimeout(animationTimer);
//       }
//     }, 5000);

//     return () => clearInterval(slideInterval);
//   }, [currentSlide, isAnimating, featuredProjects.length]);

//   useEffect(() => {
//     const fetchFeaturedProjects = () => {
//       const q = query(collection(db, 'projects'), where('isFeatured', '==', true));
//       const unsubscribe = onSnapshot(q, (querySnapshot) => {
//         const fetchedProjects = querySnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           featureImage: doc.data().featureImage,
//         }));
        
//         setFeaturedProjects(fetchedProjects);
//         setLoading(false); 
//       }, (error) => {
//         console.error('Error fetching featured projects:', error);
//         setError(error.message);
//         setLoading(false); 
//       });

//       return () => unsubscribe(); 
//     };

//     fetchFeaturedProjects();
//   }, []);

//   const handleProjectClick = (projectId) => {
//     // Navigate to project details page
//     navigate(`/projects/${projectId}`);
//   };

//   return (
//     <div
//       className="header-container"
//       style={{
//         position: 'relative',
//         display: 'flex',
//         backgroundColor: '#E54141',
//         padding: '80px 0',
//         height: '105vh',
//         overflow: 'hidden',
//       }}
//     >
//       <div
//         className="header-slider"
//         style={{
//           position: 'relative',
//           width: '100%',
//           height: '100%',
//           overflow: 'hidden',
//         }}
//       >
//         {slides.map((slides, index) => (
//           <div
//             key={index}
//             className="header-slide"
//             onClick={() => handleProjectClick(slides.id)}
//             style={{
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               width: '100%',
//               height: '100%',
//               zIndex: index === currentSlide ? 2 : 1,
//               transform: 
//                 index === currentSlide 
//                   ? 'translateX(0)' 
//                   : index === nextSlide && isAnimating 
//                     ? 'translateX(100%)' 
//                     : 'translateX(-100%)',
//               opacity: index === currentSlide ? 1 : 1,
//               transition: 'transform 1s ease-in-out, opacity 1s ease-in-out',
//               cursor: 'pointer', // Add cursor pointer to indicate clickability
//             }}
//           >
//             {/* Slide Image */}
//             <img
//               src={slides.image}
//               alt={slides.title}
//               style={{
//                 objectFit: 'cover',
//                 width: '100%',
//                 height: '100%',
//               }}
//             />
//             {/* Text Overlay */}
//             <div
//               className="header-text-wrapper"
//               style={{
//                 position: 'absolute',
//                 left: '2%',
//                 top: '85%',
//                 transform: 'translateY(-50%)',
//                 zIndex: 3,
//                 opacity: index === currentSlide ? 1 : 1,
//                 transition: 'opacity 1s ease-in-out',
//               }}
//             >
//               <h1
//                 style={{
//                   fontFamily: 'Poppins-SemiBold',
//                   color: '#E9E9E1',
//                   fontSize: 'clamp(40px, 6vw, 90px)',
//                   fontWeight: '900',
//                   margin: '0 0 20px 0',
//                 }}
//               >
//                 {slides.title}
//               </h1>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Header;